import { Location } from '@eventbrite/discover-utils';
import { gettext } from '@eventbrite/i18n';
import { FormattedLocationResponse } from '../../api';

export const categoryRadiusMap: Record<string, string> = {
    'auto-boat-and-air': '50mi',
    business: '5mi',
    'charity-and-causes': '5mi',
    community: '4mi',
    'family-and-education': '5mi',
    fashion: '7mi',
    'film-and-media': '4mi',
    'food-and-drink': '5mi',
    government: '15mi',
    health: '5mi',
    hobbies: '15mi',
    'home-and-lifestyle': '6mi',
    music: '6mi',
    other: '7mi',
    arts: '5mi',
    spirituality: '10mi',
    'school-activities': '9mi',
    'science-and-tech': '6mi',
    holiday: '6mi',
    'sports-and-fitness': '6mi',
    'travel-and-outdoor': '22mi',
};

export const getNearbyEventsCarouselTitle = (
    locationData?: FormattedLocationResponse,
    deviceLocation?: Location,
): string => {
    const nearbyEventsCarouselTitle =
        deviceLocation?.currentPlace === locationData?.currentPlace
            ? gettext('Events near you').toString()
            : gettext('Best events in %(currentPlace)s', {
                  currentPlace: locationData?.currentPlace,
              }).toString();

    return nearbyEventsCarouselTitle;
};
